

$(function() {
   let body = $("body");

   body.on('click',".modal-close",function(){
       $(this).closest(".basic-info-form").removeClass("show").remove();

       if(body.find(".basic-info-form").length === 0){
           body.removeClass("modal-open")
       }
   })
    body.on('click',".terms-modal-close",function(){
        const termsInfoModalContent = $("#terms-info-modal-content")
        termsInfoModalContent.removeClass("show").removeClass("modal");
        setTimeout(() => termsInfoModalContent.addClass("d-none"),0);
        body.removeClass("modal-open");
    })
    body.on('click',".terms-modal-open",function(e){
        e.preventDefault();
        e.stopPropagation();
        const termsInfoModalContent = $("#terms-info-modal-content")
        termsInfoModalContent.addClass("modal").removeClass("d-none");
        setTimeout(function(){
            termsInfoModalContent.addClass("show")
        },10);
        body.addClass("modal-open");
    })
});
